module.exports = __webpack_public_path__ + "061994cfb3818d8236538862142171c0.png";